
const DOMAIN_NO_RECEIVERS_TO = 8941;

export const endpoint = {
  usersWithEmail: ({caseId, query}) => `/case/${caseId}/field/${DOMAIN_NO_RECEIVERS_TO}/options/emailaddress${ query ? '/search' : ''}`,
  shareDocument: ({caseId}) => `/case/${caseId}/emails`,
  usersWithEmailDraft: ({draftId, domainNoUsers, query}) => 
    `/case/draft/${draftId}/field/${domainNoUsers}/options/emailaddress${ query ? '/search' : ''}`
};

export const translations = {
  share_case: 8064,
  share_case_by_email: 8065,
  select_users_info: 8066,
  recipients: 8067,
  message_to_receiver: 8068,
  cancel: 3273,
  send: 5863,
  case_was_shared: 8074,
  share_failed: 8075,
  no_user_email_exists: 8082,
  go_to_profile: 8083,
  external_recipients: 8289,
  unlock_case: 9689,
  
  textClose: 4329,
  textOptionsDone: 7338,
  textOptionsLoadError: 7524,
  textOptionsNotFound: 7644,
  textOptionsTitle: 7344,
  textSelectFromList: 7343,
  textSuggestions: 7346
};
